/**
 * FileDownloadIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FileDownloadIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21 16a1 1 0 0 0-1 1v2H4v-2a1 1 0 1 0-2 0v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a1 1 0 0 0-1-1m-9.71-1.29a1 1 0 0 0 1.42 0l5-5a1.004 1.004 0 1 0-1.42-1.42L13 11.59V4a1 1 0 1 0-2 0v7.59l-3.29-3.3a1.004 1.004 0 0 0-1.42 1.42z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FileDownloadIcon = makeIcon('FileDownloadIcon', FileDownloadIconSvg)
